import { useInstance, createRef } from 'intact-vue-next';
import { useDraggable as useBaseDraggable } from '../../hooks/useDraggable';
import { useState } from '../../hooks/useState';
export function useDraggable(elementRef) {
  var instance = useInstance();
  var barRef = createRef();
  var barWidth = useState(null);
  var x;
  var height;
  var width;
  var maxWidth;
  function onStart(e) {
    var _instance$get = instance.get(),
      disabled = _instance$get.disabled,
      beforeChange = _instance$get.beforeChange;
    if (disabled || beforeChange) return;
    x = e.clientX;
    height = barRef.value.clientHeight;
    width = barRef.value.clientWidth;
    maxWidth = elementRef.value.clientWidth;
  }
  function onMove(e) {
    var left = e.clientX - x;
    var newWidth = Math.min(Math.max(height, width + left), maxWidth);
    barWidth.set(newWidth);
  }
  function onEnd(e) {
    // unmounted
    if (!e) return;
    elementRef.value.blur();
    // treat mousedown -> mouseup as click
    if (x === e.clientX) {
      barWidth.set(null);
      instance.toggle(false);
    } else {
      // cancel this operation if the distance less than half of width
      var percent = (barWidth.value - height / 2) / maxWidth;
      if (!instance.isChecked()) {
        if (percent >= 0.5) {
          instance.check();
        }
      } else if (percent < 0.5) {
        instance.uncheck();
      }
      var _instance$get2 = instance.get(),
        _width = _instance$get2.width,
        _height = _instance$get2.height;
      if (!instance.isChecked() && _width && _height) {
        barWidth.set(+_height);
      } else {
        barWidth.set(null);
      }
    }
  }
  var _useBaseDraggable = useBaseDraggable({
      onStart: onStart,
      onMove: onMove,
      onEnd: onEnd
    }),
    start = _useBaseDraggable.start,
    dragging = _useBaseDraggable.dragging;
  return {
    start: start,
    dragging: dragging,
    barRef: barRef,
    barWidth: barWidth
  };
}